// frontend/src/constants/providers.js
export const providerModels = {
  openai: ["gpt-5.6-terra", "gpt-5.6-sol", "gpt-5.6-luna", "gpt-5.2", "gpt-5.1", "gpt-4o", "gpt-4.1"],
  anthropic: ["claude-sonnet-4-6", "claude-opus-4-6", "claude-haiku-4-5-20251001"],
  gemini: ["gemini-3-flash-preview", "gemini-2.5-pro", "gemini-2.5-flash"],
  kimi: ["moonshot-v1-128k", "kimi-k2-0711-preview"],
  qwen: ["qwen3.5", "qwen-plus", "qwen-max"],
  together: ["meta-llama/Llama-3.3-70B-Instruct-Turbo", "Qwen/Qwen3-235B-A22B-Instruct-2507"],
  openrouter: ["openai/gpt-5.2", "anthropic/claude-sonnet-4.5", "qwen/qwen3.5"],
  ollama: ["llama3.3", "llama3.2", "qwen3", "mistral", "gemma3", "phi4"],
};
